import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useEffect, useState } from 'react';
import { Alert } from '../Icons/Alert';
import { Error } from '../Icons/Error';
import styles from './Toast.module.scss';
export var ToastType;
(function (ToastType) {
    ToastType["attention"] = "attention";
    ToastType["warning"] = "warning";
})(ToastType || (ToastType = {}));
const IconsByState = {
    attention: _jsx(Alert, {}),
    warning: _jsx(Error, {}),
};
export const Toast = ({ toast, onRemove, timeToRemove }) => {
    const [show, setShow] = useState(false);
    const [fadeOut, setFadeOut] = useState(false);
    useEffect(() => {
        const timerShow = setTimeout(() => setShow(true), 400);
        const timerFadeOut = setTimeout(() => setFadeOut(true), timeToRemove - 1000);
        const timerRemove = setTimeout(() => onRemove(toast.id), timeToRemove);
        return () => {
            clearTimeout(timerShow);
            clearTimeout(timerFadeOut);
            clearTimeout(timerRemove);
        };
    }, [onRemove, timeToRemove, toast.id]);
    if (!show) {
        return null;
    }
    return (_jsxs("div", { className: cn(styles.toast, styles[toast.type], {
            [styles.fadeOut]: fadeOut,
        }), children: [_jsx("span", { children: IconsByState[toast.type] }), _jsx("p", { children: toast.message })] }));
};
